import { EmptyState, Flex } from '@cad-arc';

export function NoResults() {
    return (
        <Flex justifyContent="center" alignItems="center" h="100%" w="100%">
            <EmptyState
                visual="Search"
                title="No results found"
                subtitle="Broaden your search for more results"
            />
        </Flex>
    );
}
